export default {"src":"/_next/static/media/logo_white.86860124.svg","height":268,"width":1040,"blurWidth":0,"blurHeight":0};